import { render } from "./Carousel.vue?vue&type=template&id=18ec51e4"
const script = {}

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSK\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__